import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer bg-none mt-auto pt-5" }
const _hoisted_2 = { class: "container pt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-2 pt-4" }
const _hoisted_5 = { class: "nav-item py-1" }
const _hoisted_6 = { class: "nav-item py-1" }
const _hoisted_7 = { class: "nav-item py-1" }
const _hoisted_8 = { class: "col-6 col-md-2 pt-4" }
const _hoisted_9 = { class: "nav-item py-1" }
const _hoisted_10 = { class: "nav-item py-1" }
const _hoisted_11 = { class: "nav-item py-1" }

import { ref, onMounted } from 'vue';
import BrandMarquee from "@/components/general/BrandMarquee.vue";
import { CmsBaseUrl } from "@/utils/functions";
import { useApolloClient } from '@vue/apollo-composable';
import { getBrandMarquee } from "@/utils/graphql";


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const logos = ref<Array<{ src: string; alt: string; link: string }>>([]);

const { resolveClient } = useApolloClient();
const ApolloClient = resolveClient();

onMounted(async () => {
    try {
        const result = await getBrandMarquee(ApolloClient);
        logos.value = result as Array<{ src: string; alt: string; link: string }>;
    } catch (error) {
        console.error("Failed to load marquee logos in Footer:", error);
    }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-12 col-md-4 text-start text-dark" }, [
          _createElementVNode("p", { class: "pb-3 logo-style navbar-brand" }, "/// nologo studios"),
          _createElementVNode("span", { class: "pb-3 small text-muted" }, "We are a dedicated digital studio committed to crafting high-end, bespoke solutions for businesses worldwide. Our team of passionate technologists and creators takes pride in bringing ambitious ideas to life with precision and expertise. We partner with companies of all sizes, empowering them with the digital tools they need to succeed and grow.")
        ], -1)),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-12 col-md-2" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("li", { class: "nav-item py-1" }, [
            _createElementVNode("a", { href: "https://admin.nologostudios.com/media/Nologo%20Studios%20(Pty)%20Ltd%20PAIA%20MANUAL%20Sep2024.pdf" }, "PAIA Manual")
          ], -1)),
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/privacy-policy" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Privacy Policy", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, { to: "/services#FAQs" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("FAQ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, { to: "/contact" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Contact Us", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, { to: "/services" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Services", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, { to: "/about-us" }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("About", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, { to: "/careers" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Careers", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-12 col-md-2 pt-4" }, [
          _createElementVNode("p", { class: "fw-semibold pt-1 mb-1" }, "Contact Us"),
          _createElementVNode("li", { class: "nav-item py-1" }, [
            _createElementVNode("a", {
              href: "mailto:info@nologostudios.com",
              class: "fw-semibold text-primary"
            }, "info@nologostudios.com")
          ]),
          _createElementVNode("a", null, "No. 4 Brendon Lane, Westville, 3629")
        ], -1)),
        _createVNode(BrandMarquee)
      ])
    ]),
    _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"container pb-3\" data-v-584586a5><div class=\"row\" data-v-584586a5><div class=\"col-4 text-start text-dark d-flex justify-content-start\" data-v-584586a5><div class=\"footer-item-1\" data-v-584586a5><a href=\"https://za.linkedin.com/company/nologo-studios\" target=\"_blank\" data-v-584586a5><i class=\"fa-brands fa-linkedin-in h3 me-3\" data-v-584586a5></i></a><a href=\"https://www.facebook.com/nologostudios/\" target=\"_blank\" data-v-584586a5><i class=\"fa-brands fa-facebook h3\" data-v-584586a5></i></a></div></div><div class=\"col-4 d-flex justify-content-center\" data-v-584586a5><div class=\"footer-item-2\" data-v-584586a5><span class=\"text-muted small\" data-v-584586a5>© 2025</span></div></div><div class=\"col-4 d-flex justify-content-end\" data-v-584586a5><div class=\"footer-item-3\" data-v-584586a5><span class=\"text-muted small\" data-v-584586a5>All rights reserved</span></div></div></div></div>", 1))
  ]))
}
}

})